import { SET_POPUP } from '../constants/constants';

const initialState = {
  customPopupMessage: false,
};

const popupReducer = (state = initialState, action = {}) => {
  const { payload = {} } = action;
  if (action.type === SET_POPUP)
    return {
      ...state,
      ...payload,
    };
  else return state;
};

export default popupReducer;
